/**
 * 生成基础axios对象，并对请求和响应做处理
 * 前后端约定接口返回解构规范
 * {
 *    code:0,或200
 *    data:"成功获取到的数据",
 *    message:"成功"
 * }
 */
import axios from 'axios'
import {Toast} from 'vant'
import {getToken} from './auth'

// 创建一个独立的axios实例
const service = axios.create({
    // 设置baseUr地址,如果通过proxy跨域可直接填写base地址
    baseURL: '/api',
    // 定义统一的请求头部
    headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
    },
    // 配置请求超时时间
    timeout: 10000,
    // 跨域请求时是否需要访问凭证;如果用的JSONP，可以配置此参数带上cookie凭证，如果是代理和CORS不用设置
    withCredentials: false
});
// 请求拦截
service.interceptors.request.use(
    config => {
        Toast.loading({
            duration: 0,
            forbidClick: true
        })
        // 自定义header，可添加项目token
        config.headers['Content-Type'] = 'application/json;charset=utf-8'
        config.headers['Authorization'] = 'Bearer ' + getToken()
        return config
    }
)
// 返回拦截
service.interceptors.response.use(
    (response) => {
        Toast.clear()
        return response;
        // 获取接口返回结果
        /*const res = response;
        // code为0，直接把结果返回回去，这样前端代码就不用在获取一次data.
        if (res.status === 0 || res.status === 200) {
            return res;
        } else if (res.status === 10000) {
            // 10000假设是未登录状态码
            Toast.fail(res.message);
            // 也可使用router进行跳转
            window.location.href = '/login';
            return res;
        } else {
            // 错误显示可在service中控制，因为某些场景我们不想要展示错误
            // Toast.fail(res.message);
            return res;
        }*/
    }, () => {
        Toast.fail('网络请求异常，请稍后重试!');
    });
export default service;